﻿const body = document.querySelector('body');

const forms = document.querySelectorAll('form');

const loadingElement = document.querySelector('#loading-element');

forms.forEach(form => {
  let disableLoading = Boolean(form.dataset.disableloading);
  if (!disableLoading) {
	form.addEventListener('submit', function (e) {
	  showLoading(loadingElement);

	  //e.preventDefault()
	  //setTimeout(function () { form.submit() }, 2000);
	});
  }
});

function showLoading(loadingElement) {
  loadingElement.style.zIndex = 10000;
  loadingElement.style.opacity = 1;
}
function hideLoading(loadingElement) {
  loadingElement.style.zIndex = -1;
  loadingElement.style.opacity = 0;
}

